import { Token } from "../Token";

export class MockToken {
  public familyToken: Token = {
    accessToken: "A",
    refreshToken: "B",
  };

  public userToken: Token = {
    accessToken: "C",
    refreshToken: "D",
  };
}
